import { useEffect, useState } from "react";
import { api } from "./api";
import { PROGRAMS } from "../pages/engagement/constants";

export function usePrograms() {
  const [programs, setPrograms] = useState(PROGRAMS);
  useEffect(() => {
    api.get("/programs").then((r) => {
      if (r.data.length) setPrograms(r.data.map((p) => p.name));
    }).catch(() => {});
  }, []);
  return programs;
}
